import { render, staticRenderFns } from "./SuppliesView.vue?vue&type=template&id=930d376a"
import script from "./SuppliesView.vue?vue&type=script&lang=js"
export * from "./SuppliesView.vue?vue&type=script&lang=js"
import style0 from "./SuppliesView.vue?vue&type=style&index=0&id=930d376a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports